import { type FetchMinimalWithdrawalAmountByCurrencyTypeParams } from '@capsicum/common';
import { fetchMinimalWithdrawalAmountByCurrencyType } from '@capsicum/socios-core';
import { useQuery } from '@tanstack/react-query';

/**
 * @params FetchMinimalWithdrawalAmountByCurrencyTypeParams
 * @returns minimum amount to withdraw by currency type passed
 */
export const useWalletWithdrawalMinimumAmountQuery = (params: FetchMinimalWithdrawalAmountByCurrencyTypeParams) =>
	useQuery({
		queryFn: () => fetchMinimalWithdrawalAmountByCurrencyType(params),
		queryKey: ['fetchMinimalWithdrawalAmountByCurrencyType', params]
	});
